import { CATEGORY } from './categories.constants';

export const AI_DETECTION_ENDPOINTS: Record<number, { preProcess?: string; taskStatus: string }> = {
  [CATEGORY.FLOORING.numericId]: {
    preProcess: '/mflooring/flooring/point-process',
    taskStatus: '/mflooring/flooring-task-status',
  },
  [CATEGORY.DRYWALL.numericId]: {
    preProcess: '/mdrywall/drywall/point-process',
    taskStatus: '/mdrywall/task-status',
  },
  [CATEGORY.DOORS_WINDOWS.numericId]: {
    preProcess: '/ai/v1/doors-windows/pre-process-windows-doors',
    taskStatus: '/ai/v1/doors-windows/task-status',
  },
  [CATEGORY.INTERIOR_PAINT.numericId]: {
    preProcess: '/ai/v1/interior-paints/point-process',
    taskStatus: '/ai/v1/interior-paints/task-status',
  },
  [CATEGORY.FIXTURES.numericId]: {
    preProcess: '/ai/v1/plumbing/point-process',
    taskStatus: '/ai/v1/plumbing/task-status',
  },
};

export const SUPPORTED_AI_DETECTION_CATEGORY_IDS = Object.freeze(
  Object.keys(AI_DETECTION_ENDPOINTS).map(Number),
);

export const API_ENDPOINTS = {
  auth: {
    login: '/auth/login',
    signup: '/auth/signup',
    forgotPassword: '/auth/forgot_password',
    resetPassword: '/auth/reset_password',
    adminSignin: '/auth/admin/signin',
    builderSignin: '/auth/builder/signin',
    builderSignup: '/auth/builder/signup',
    verifyEmail: '/auth/verify_email',
    resendOtp: '/auth/resend_otp',
    builderGetUserDetails: (userId: string) => `/auth/builder/get-user-details/${userId}`,
    editUserDetails: (userId: string) => `/auth/builder/edit-user-details/${userId}`,
    deleteAccount: '/auth/builder/delete_account',
  },
  project: {
    list: '/project/project_list_new',
    create: '/project/add_project',
    update: (projectId: number) => `/project/edit_project/${projectId}`,
    delete: (projectId: number) => `/project/delete_project/${projectId}`,
    deleteDocuments: '/project/delete_documents',
    uploadDocuments: '/project/upload_documents',
    viewDocuments: '/project/view-documents-v2',
    detectionScope: (projectId: number) => `/project/${projectId}/detection-scope`,
    scales: '/project/get-scales',
    assignFloor: '/project/assign-floor',
    getAssignedFloors: (projectId: number) => `/project/get-assigned-floors/${projectId}`,
    deleteAssignedFloor: (id: number) => `/project/delete-assigned-floor/${id}`,
    editAssignedFloor: (id: number) => `/project/edit-assigned-floor/${id}`,
    getPointsData: (projectId: number) => `/project/get-points-data/${projectId}`,
    getPlumbingPointsData: (projectId: number) => `/project/get-points-data-plumbing/${projectId}`,
    getHvacPointsData: (projectId: number) => `/project/get-points-data-hvac/${projectId}`,
    getColumnsPointsData: (projectId: number) => `/project/get-points-data-columns/${projectId}`,
    getBeamsPointsData: (projectId: number) => `/project/get-points-data-beams/${projectId}`,
    getDoorsWindowsPoints: (projectId: number) => `/project/get-doors-windows-points/${projectId}`,
    updateContourPoints: '/project/update-contour-points',
    updateContourPointsDoorsWindows: '/project/update-contour-points-doors-windows',
    updateContourPointsHvac: '/project/update-contour-points-hvac',
    adminSettings: '/project/admin/settings',
    pricingDrawer: (projectId: number) => `/project/${projectId}/pricing-drawer`,
    pricingDrawerPlumbing: (projectId: number) => `/project/${projectId}/pricing-drawer/plumbing`,
    pricingDrawerDrywall: (projectId: number) => `/project/${projectId}/pricing-drawer/drywall`,
    pricingDrawerInteriorPaints: (projectId: number) => `/project/${projectId}/pricing-drawer/interior-paints`,
    pricingDrawerDoorsWindows: (projectId: number) => `/project/${projectId}/pricing-drawer/doors-windows`,
    drywallRoomHeights: (projectId: number) => `/project/${projectId}/drywall/room-heights`,
    interiorPaintRoomHeights: (projectId: number) => `/project/${projectId}/interior-paint/room-heights`,
    pricingSummary: (projectId: number) => `/project/${projectId}/pricing-summary`,
    stepperSummary: (projectId: number) => `/project/${projectId}/stepper-summary`,
  },
  adminSettings: {
    drywall: '/project/admin/settings/drywall',
    doorsWindows: '/project/admin/settings/doors-windows',
    interiorPaint: '/project/admin/settings/interior-paint',
    plumbing: '/project/admin/settings/plumbing',
  },
  onboarding: {
    addScale: '/onboarding/add-scale',
  },
  pdfCropper: {
    splitPages: '/pdf-cropper/split-pages',
  },
} as const;
